import DeviceDetector from "device-detector-js";

const deviceDetector = new DeviceDetector();
const userAgent = window?.navigator.userAgent;
const device = deviceDetector.parse(userAgent);

export const useDeviceDetector = () => {
  return device;
};
